const PROTOCOL_REGEX = /^(https?:\/\/)/i;

const isValidUrl = (url: string): boolean => {
  const trimmed = url.trim();
  if (!trimmed) return false;
  if (!PROTOCOL_REGEX.test(trimmed)) return false;

  try {
    new URL(trimmed);
    return true;
  } catch {
    return false;
  }
};

export function validateAiApplicationCreateName({
  name,
  nameErrorMessage,
}: {
  name: string;
  nameErrorMessage: string;
}) {
  return name.trim().length < 2 ? nameErrorMessage : '';
}

export function validateAiApplicationCreateUrl({
  url,
  urlErrorMessage,
}: {
  url: string;
  urlErrorMessage: string;
}) {
  return !url.trim() || !isValidUrl(url) ? urlErrorMessage : '';
}
